import React, { useState, useEffect } from "react";
import * as yup from "yup";
import { checkObjectValues } from "utils/checkEmptyValues";
import { mapLocationCategoriesToApi } from "../mapDataToApi";
import { validationSchema } from "../validationSchema";
import { addNewLocationCategory } from "../api";
import LocationCategoryForm from "./LocationCategoryForm";

function CreateLocationCategory({ onClose, onSuccess, setIsLocationCategoriesChange }) {
    const [newLocationCategory, setNewLocationCategory] = useState({
        arabicName: "",
        englishName: "",
        code: "",
    });
    const [errorList, setErrorList] = useState(null);
    const [errors, setErrors] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [nameArError, setNameArError] = useState();
    const [nameEnError, setNameEnError] = useState();
    const [codeError, setCodeError] = useState();

    const clearLocationCategoryData = () => {
        setNewLocationCategory({
            arabicName: "",
            englishName: "",
            code: "",
        });
    };
    const handleLocationCategoryChange = (e) => {
        const { name, value } = e?.target;
        setNewLocationCategory({
            ...newLocationCategory,
            [name]: value,
        });
        yup.reach(validationSchema, name)
            .validate(value)
            .then(() => setErrorList({ ...errorList, [name]: "" }))
            .catch((err) => setErrorList({ ...errorList, [name]: err.message }));
    };
    const handleSubmitLocationCategory = async (e) => {
        e.preventDefault();

        try {
            const response = await validationSchema
                .validate(newLocationCategory, { abortEarly: false })
                .then(async () => {
                    setIsLoading(true);
                    addNewLocationCategory(mapLocationCategoriesToApi(newLocationCategory))
                        .then(() => {
                            setIsLoading(false);
                            onSuccess(newLocationCategory.arabicName);
                            clearLocationCategoryData();
                        })
                        .catch((error) => {
                            setIsLoading(false);
                            setErrors(error);
                            if (error?.name_ar) {
                                setNameArError(error?.name_ar[0]);
                            }
                            if (error?.name_en) {
                                setNameEnError(error?.name_en[0]);
                            }
                            if (error?.code) {
                                setCodeError(error?.code[0]);
                            }
                        });
                });
        } catch (error) {
            const errorMessage = error?.inner?.reduce(
                (acc, error) => ({
                    ...acc,
                    [error?.path]: error?.message,
                }),
                {}
            );
            setErrorList(errorMessage);
        }
    };
    useEffect(() => {
        if (checkObjectValues(newLocationCategory)) {
            setIsLocationCategoriesChange(true);
        } else {
            setIsLocationCategoriesChange(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newLocationCategory]);

    useEffect(() => {
        setNameArError(null);
    }, [newLocationCategory.arabicName]);
    useEffect(() => {
        setNameEnError(null);
    }, [newLocationCategory.englishName]);
    useEffect(() => {
        setCodeError(null);
    }, [newLocationCategory.code]);

    return (
        <LocationCategoryForm
            locationCategoryData={newLocationCategory}
            handleLocationCategoryChange={handleLocationCategoryChange}
            onClose={onClose}
            handleLocationCategorySubmit={handleSubmitLocationCategory}
            errors={errors}
            errorList={errorList}
            nameArError={nameArError}
            nameEnError={nameEnError}
            codeError={codeError}
            isLoading={isLoading}
            buttonName="Create"
        />
    );
}

export default CreateLocationCategory;
